var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoYellow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 0C3.584 0 0 3.584 0 8C0 12.416 3.584 16 8 16C12.416 16 16 12.416 16 8C16 3.584 12.416 0 8 0ZM8.79987 4H7.19987V5.6H8.79987V4ZM8.79987 7.20052H7.19987V12.0005H8.79987V7.20052ZM1.59993 8.00026C1.59993 11.5283 4.47193 14.4003 7.99994 14.4003C11.5279 14.4003 14.3999 11.5283 14.3999 8.00026C14.3999 4.47226 11.5279 1.60026 7.99994 1.60026C4.47193 1.60026 1.59993 4.47226 1.59993 8.00026Z",
    fill: "#FCBF07"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoYellow);
export default __webpack_public_path__ + "static/media/info-yellow.038d67c55df2911ba9897cd21b690df2.svg";
export { ForwardRef as ReactComponent };